export default __webpack_public_path__ + "static/media/EHR.d932ccac.jpg";